import { render, staticRenderFns } from "./DisplayQuestion.vue?vue&type=template&id=ec85a222&scoped=true&"
import script from "./DisplayQuestion.vue?vue&type=script&lang=js&"
export * from "./DisplayQuestion.vue?vue&type=script&lang=js&"
import style0 from "./DisplayQuestion.vue?vue&type=style&index=0&id=ec85a222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec85a222",
  null
  
)

export default component.exports